const EnvConfig: { [key: string]: string | undefined } = {
  APP_NAME: process.env.REACT_APP_NAME,
  API_URL: process.env.REACT_APP_API_URL,
};

console.log(EnvConfig);

export default EnvConfig;
